import axios from 'axios';
import util from './util';
import { useColumnSetting } from '@/composables/useColumnSettings';

const loginBase = `${window.location.protocol}//${window.location.hostname}`;
const config = {
  axios,
  baseURL: '',
  loginRedirectURL: '',
  successRedirectURL: ''
};

const { clearAllColumnsSetting } = useColumnSetting('');

const validateSession = () => {
  return new Promise((resolve) => {
    const url = `${loginBase}/console/auth/session`;
    axios
      .get(url, { withCredentials: true, 'Content-Type': 'application/json' })
      .then(async (res) => {
        const data = res.data === undefined ? res : res.data;
        if (data === null || data === undefined || data === '') {
          goToLogin();
        } else {
          await util.setSessionStorageData(data);
          resolve(data);
        }
      })
      .catch((error) => {
        goToLogin();
      });
  });
};

const validateSessionExpiredChangeRole = () => {
  return new Promise((resolve) => {
    const url = `${loginBase}/console/auth/session`;
    axios
      .get(url, { withCredentials: true, 'Content-Type': 'application/json' })
      .then(async (res) => {
        const data = res.data === undefined ? res : res.data;
        if (data === null || data === undefined || data === '') {
          goToLogin();
        } else {
          resolve(data);
        }
      })
      .catch((error) => {
        goToLogin();
      });
  });
};

const goToLogin = () => {
  let url = `${loginBase}/console/auth/login`;

  if (config.loginRedirectURL) {
    url += `?redirect_uri=${config.loginRedirectURL}`;
  }
  window.sessionStorage.clear();
  clearAllColumnsSetting();
  const language = util.getLocale();
  if (language) {
    url += `?locale=${language}`;
  } else {
    url += `?locale=en`;
  }
  util.setWindowLocation(url);
};

const logout = () => {
  const url = `${loginBase}/console/auth/logout`;
  sessionStorage.clear();
  clearAllColumnsSetting();
  window.location.href = url;
};
export default {
  config,
  validateSession,
  validateSessionExpiredChangeRole,
  goToLogin,
  logout
};
